'use client';

import { Box } from '@mui/material';
import { ReactNode } from 'react';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';

interface FormItemProps {
  label: string;
  required?: boolean;
  children: ReactNode;
  onClick?: () => void;
}

export default function FormItem({ label, required, children, onClick }: FormItemProps) {
  return (
    <Box>
      {/* 移动端：垂直布局 */}
      <WapOnly>
        <label className="block mb-2 text-base font-bb">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
        <Box className="w-full" onClick={onClick}>
          {children}
        </Box>
      </WapOnly>

      {/* Web端：水平布局，label在左侧 */}
      <WebOnly>
        <Box className="flex items-center gap-4">
          <label className="flex-shrink-0 w-[220px] text-base font-bb text-right mr-[25px]">
            {required && <span className="text-red-500">*</span>} {label}
          </label>
          <Box className="w-[500px]">{children}</Box>
        </Box>
      </WebOnly>
    </Box>
  );
}
